/*
 * Transparent header.
 *
 * The transparent state itself is pure CSS (see transparent-header.css). This file
 * only handles the parts CSS cannot do:
 *   - keeping --transparent-header-height in sync when the header resizes
 *   - toggling .header-solid on <body> once the hero has scrolled past the header
 */
(() => {
  const MARKER = '[data-transparent-header]';
  let observer = null;
  let resizeTimer = null;

  // The header sits in a section group, so its wrapper id is
  // shopify-section-sections--xxxxx__header. .cc-header (from the header section's
  // schema "class") is the stable handle — main.js uses it for the sticky class too.
  const headerSection = () => document.querySelector('.cc-header');

  /**
   * Returns the opted-in hero, but only when it is the first section on the page.
   * Must mirror the :has() selector in transparent-header.css exactly — note the
   * :first-child, which (deliberately) fails on pages that render breadcrumbs
   * ahead of the first section.
   */
  function getHero() {
    const main = document.getElementById('main-content');
    const first = main && main.querySelector(':scope > .shopify-section:first-child');
    return first ? first.querySelector(MARKER) : null;
  }

  function setHeight() {
    const header = headerSection();
    if (!header) return 0;
    const height = header.offsetHeight;
    document.documentElement.style.setProperty('--transparent-header-height', `${height}px`);
    return height;
  }

  function init() {
    if (observer) {
      observer.disconnect();
      observer = null;
    }
    document.body.classList.remove('header-solid');

    const hero = getHero();
    if (!hero) return;

    const height = setHeight();

    // The hero stops "covering" the header once its bottom edge passes the header's.
    observer = new IntersectionObserver(([entry]) => {
      document.body.classList.toggle('header-solid', !entry.isIntersecting);
    }, { rootMargin: `-${height}px 0px 0px 0px`, threshold: 0 });

    observer.observe(hero);
  }

  function handleResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', handleResize);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', init);
    document.addEventListener('shopify:section:reorder', init);
  }
})();
